// Helpers partagés pour le téléchargement des logos clients.

// Extension du fichier : on retire d'abord la query string, sinon un paramètre
// contenant un point (URL signée, cache-busting) fausserait l'extension.
export function logoFileName(business) {
  var b = business || {}
  var ext = (b.logo_url || '').split('?')[0].split('.').pop() || 'png'
  var slug = (b.name || 'client')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return (b.prefix || b.id) + '_' + slug + '.' + ext
}

export function saveBlob(blob, filename) {
  var url = window.URL.createObjectURL(new Blob([blob]))
  var a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}
